<template>
    <v-app id="inspire">
        <v-navigation-drawer app
                             :dark="dark"
                             fixed
                             :clipped="$vuetify.breakpoint.mdAndDown"
                             v-model="drawer"
                             :width="$vuetify.breakpoint.width <= 320 ? 280 : 300"
                             v-if="check">
            <v-layout column fill-height>
                <v-list v-if="check">
                    <!-- logged in User -->
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-icon>
                                person
                            </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{fullName()}}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile :to="'/'">
                        <v-list-tile-action>
                            <v-icon>
                                home
                            </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                Home
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile :to="{name: 'search'}">
                        <v-list-tile-action>
                            <v-icon>
                                people
                            </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                Search
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                  <v-list-tile :to="{name: 'database'}">
                    <v-list-tile-action>
                      <v-icon>
                        file_download
                      </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        Database
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                    <v-list-tile :to="{ name: 'about' }">
                        <v-list-tile-action>
                            <v-icon>info</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>About</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
                <v-spacer></v-spacer>
                <v-list>
                    <v-list-tile @click="internalLogout()">
                        <v-list-tile-action>
                            <v-icon>
                                exit_to_app
                            </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                Logout
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <!--<v-list-tile :to="{ name: 'help' }">-->
                        <!--<v-list-tile-action>-->
                            <!--<v-icon>help</v-icon>-->
                        <!--</v-list-tile-action>-->
                        <!--<v-list-tile-content>-->
                            <!--<v-list-tile-title>Help</v-list-tile-title>-->
                        <!--</v-list-tile-content>-->
                    <!--</v-list-tile>-->
                </v-list>
            </v-layout>
        </v-navigation-drawer>
        <v-toolbar
                color="primary"
                dark
                app
                fixed
        >
            <v-toolbar-side-icon
                    v-if="check"
                    @click.stop="drawer = !drawer">
            </v-toolbar-side-icon>
            <v-toolbar-title class="ml-0 pl-3">
                <span>{{title}}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="!check" :to="{name: 'login'}" color="primary" icon title="Login">Login</v-btn>
            <v-btn v-if="check && $vuetify.breakpoint.smAndUp"
                   @click="internalLogout()"
                   icon
                   title="Logout">
                <v-icon>exit_to_app</v-icon>
            </v-btn>
        </v-toolbar>
        <v-content>
            <v-slide-y-transition mode="out-in">
                <router-view/>
            </v-slide-y-transition>
        </v-content>
        <v-footer fixed app>
          <v-flex class="ml-3" py-3 text-xs-left xs12>
            &copy;{{ new Date().getFullYear() }} — <strong>Accessible Retail</strong>
          </v-flex>
        </v-footer>
    </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Notification from './components/Notification'

export default {
  components: {
    'notification': Notification
  },
  data: () => ({
    drawer: false,
    dark: false
  }),
  props: {
    source: String
  },
  computed: {
    ...mapGetters(
      'application', {
        title: 'title'
      }
    ),
    check () {
      return this.$store.state.auth.status.loggedIn
    }
  },
  methods: {
    ...mapActions(
      'auth', {
        logout: 'logout'
      }
    ),
    internalLogout () {
      this.logout().then(() => {
        this.$router.replace({ path: '/login' })
      })
    },
    fullName () {
      let user = JSON.parse(localStorage.getItem('user'))
      if (user && user.first_name && user.last_name) {
        return `${user.first_name} ${user.last_name}`
      }
    }
  }
}
</script>

<style>

    html {
        /*overflow-y: hidden;*/
    }

</style>
